import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { useImperativeHandle, useRef } from "react";
import { NativeViewGestureHandler, nativeViewProps } from "./NativeViewGestureHandler";
/*
 * This array should consist of:
 *   - All keys in propTypes from NativeGestureHandler
 *     (and all keys in GestureHandlerPropTypes)
 *   - 'onGestureHandlerEvent'
 *   - 'onGestureHandlerStateChange'
 */ var NATIVE_WRAPPER_PROPS_FILTER = _to_consumable_array(nativeViewProps).concat([
    "onGestureHandlerEvent",
    "onGestureHandlerStateChange"
]);
export default function createNativeWrapper(Component) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var // @ts-ignore if render doesn't exist it will return undefined and go further
    _Component_render;
    var ComponentWrapper = /*#__PURE__*/ React.forwardRef(function(props, ref) {
        // filter out props that should be passed to gesture handler wrapper
        var gestureHandlerProps = Object.keys(props).reduce(function(res, key) {
            // TS being overly protective with it's types, see https://github.com/microsoft/TypeScript/issues/26255#issuecomment-458013731 for more info
            var allowedKeys = NATIVE_WRAPPER_PROPS_FILTER;
            if (allowedKeys.includes(key)) {
                // @ts-ignore FIXME(TS)
                res[key] = props[key];
            }
            return res;
        }, _object_spread({}, config) // watch out not to modify config
        );
        var _ref = useRef();
        var _gestureHandlerRef = useRef();
        useImperativeHandle(ref, // @ts-ignore TODO(TS) decide how nulls work in this context
        function() {
            var node = _gestureHandlerRef.current;
            // add handlerTag for relations config
            if (_ref.current && node) {
                // @ts-ignore FIXME(TS) think about createHandler return type
                _ref.current.handlerTag = node.handlerTag;
                return _ref.current;
            }
            return null;
        }, [
            _ref,
            _gestureHandlerRef
        ]);
        return /*#__PURE__*/ _jsx(NativeViewGestureHandler, _object_spread_props(_object_spread({}, gestureHandlerProps), {
            // @ts-ignore TODO(TS)
            ref: _gestureHandlerRef,
            children: /*#__PURE__*/ _jsx(Component, _object_spread_props(_object_spread({}, props), {
                ref: _ref
            }))
        }));
    });
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    ComponentWrapper.displayName = (Component === null || Component === void 0 ? void 0 : Component.displayName) || (Component === null || Component === void 0 ? void 0 : (_Component_render = Component.render) === null || _Component_render === void 0 ? void 0 : _Component_render.name) || typeof Component === "string" && Component || "ComponentWrapper";
    return ComponentWrapper;
}
